import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-spinner-modal',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './spinner-modal.component.html',
  styleUrl: './spinner-modal.component.css'
})
export class SpinnerModalComponent {

  @Input() potential : boolean = false;

  constructor(private cdRef: ChangeDetectorRef,
    private translateService: TranslateService
  ) {

  }


  ngOnInit(): void {
    
    this.cdRef.detectChanges();
  }

}
